"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { useAuthStore } from "@/store/auth";
import { useChatStore } from "@/store/chatStore";

/**
 * AI 도구 칩 (사용자 결정 2026-05-14 — 1줄 4칩 압축).
 *
 * 옛 1×1×1×1 가로 풀폭 카드 → 4 column 칩 그리드.
 * 설명·CTA 제거 → 진입은 모두 클릭. AI 비서만 모달, 나머지는 Link.
 */

interface ToolItem {
  emoji: string;
  title: string;
}

const ITEMS = {
  ai: { emoji: "🤖", title: "AI 비서" } as ToolItem,
  image: { emoji: "🎨", title: "AI 이미지" } as ToolItem,
  sns: { emoji: "📝", title: "SNS 글" } as ToolItem,
  keyword: { emoji: "🔍", title: "키워드 분석" } as ToolItem,
};

const CHIP_CLS =
  "card flex flex-col items-center justify-center gap-1 py-3 px-1 hover:border-primary/40 transition-colors text-center";

function ChipInner({ item }: { item: ToolItem }) {
  return (
    <>
      <span className="text-2xl leading-none">{item.emoji}</span>
      <span className="text-2xs font-semibold text-text leading-tight">{item.title}</span>
    </>
  );
}

export function AiToolsSection() {
  const router = useRouter();
  const { isLoggedIn } = useAuthStore();
  const setChatOpen = useChatStore((s) => s.setOpen);

  const handleAssistantClick = () => {
    if (!isLoggedIn) {
      router.push("/login");
      return;
    }
    setChatOpen(true);
  };

  return (
    <section className="px-4 mt-6">
      <h2 className="section-title">✨ AI 도구</h2>

      <div className="grid grid-cols-4 gap-2">
        <button onClick={handleAssistantClick} className={CHIP_CLS}>
          <ChipInner item={ITEMS.ai} />
        </button>
        <Link href="/image-studio" className={CHIP_CLS}>
          <ChipInner item={ITEMS.image} />
        </Link>
        <Link href="/sns-writer" className={CHIP_CLS}>
          <ChipInner item={ITEMS.sns} />
        </Link>
        <Link href="/mypage/keyword-request" className={CHIP_CLS}>
          <ChipInner item={ITEMS.keyword} />
        </Link>
      </div>
    </section>
  );
}
